export default {
  selectMonth: 'เลือกเดือน',
  selectYearBE: 'เลือกปี (พ.ศ.)',
  selectYearAD: 'เลือกปี (ค.ศ.)',
  yearSuffix: 'พ.ศ.',
  title: 'กำหนดช่วงเวลา',
  from: 'จาก',
  to: 'ถึง',
  selectNow: 'เลือกปัจจุบัน',
  date: 'วันที่',
  time: 'เวลา',
  now: 'ปัจจุบัน',
  today: 'วันนี้',
  yesterday: 'เมื่อวาน',
  apply: 'นำไปใช้',
  cancel: 'ยกเลิก',
  clear: 'ล้างค่า',
  reset: 'รีเซ็ต',
  timezone: 'เขตเวลาที่ใช้เเสดงผล:',
  loading: 'กำลังโหลด...',
  empty: 'ไม่พบข้อมูล',
  section: {
    this: 'ภายใน',
    last: 'ย้อนหลัง',
  },
  placeholder: {
    from: 'วันที่/เวลาเริ่มต้น',
    to: 'วันที่/เวลาสิ้นสุด',
    input: 'เลือกช่วงวันที่',
  },
  presets: {
    custom: 'กำหนดเอง',
    today: 'วันนี้',
    thisWeek: 'สัปดาห์นี้',
    thisMonth: 'เดือนนี้',
    thisQuarter: 'ไตรมาสนี้',
    thisYear: 'ปีนี้',
    last1d: 'เมื่อวาน',
    last7d: '7 วันที่ผ่านมา',
    last15d: '15 วันที่ผ่านมา',
    last30d: '30 วันที่ผ่านมา',
    last1q: '90 วันที่ผ่านมา',
    last1y: 'ปีที่ผ่านมา',
  },
  relative: {
    lastXHours: 'ย้อนหลัง {n} ชั่วโมง',
    lastXDays: 'ย้อนหลัง {n} วัน',
    lastXWeeks: 'ย้อนหลัง {n} สัปดาห์',
    lastXMonths: 'ย้อนหลัง {n} เดือน',
  },
  freq: {
    hourly: 'รายชั่วโมง',
    daily: 'รายวัน',
    weekly: 'รายสัปดาห์',
    monthly: 'รายเดือน',
    quarterly: 'รายไตรมาส',
    yearly: 'รายปี',
  },
  units: {
    day: 'วัน',
    week: 'สัปดาห์',
    month: 'เดือน',
    quarter: 'ไตรมาส',
    year: 'ปี',
  },
  frequency: {
    every: 'ทุก',
    everyN: 'ทุก {n}',
    defaultDescription: 'ความถี่การแสดงผลข้อมูล: ค่าเริ่มต้นรายวันของแต่ละกราฟ',
    desc: 'ความถี่การแสดงผลข้อมูล: ทุก {n} {unit}',
    startOnDay: 'โดยเริ่มต้น ณ วันที่ {d}',
    ariaLabel: 'ตัวเลือกความถี่',
    defaultTab: 'ค่าเริ่มต้น',
    onDayOfMonthPrefix: 'โดยเริ่มต้น ณ วันที่',
    onDayOfMonthSuffix: 'ของเดือน',
    onWeekSuffix: 'สัปดาห์ (เริ่ม วันอาทิตย์ ถึง วันเสาร์)',
  },
};
